import { createEvent, useEvent } from '@cobuildlab/react-simple-state';
import { COMPANY_WIDE_BRANCH } from '@rapid-recovery-agency-inc/insightt-shared';

import { SEARCH_PARAM_KEYS } from '../constants/app.constants';
import { getSearchParam } from './html';

/*
  This event is used to store the current value of the top branch menu.

  TODO:
  1) Replace in the application the same repeated event
  2) Remove repeated events in the following files

  - src/modules/shared/events/branch-event.js
  - src/shared/branchEvent.js
  - src/views/app/shift/for-admin/shared/branchEvent.js
*/

const branchFromURL = getSearchParam(SEARCH_PARAM_KEYS.branch);
const branchInitialValue = branchFromURL === null ? COMPANY_WIDE_BRANCH : { id: Number(branchFromURL), name: '' };
/**
 * @deprecated
 */
export const onBranchEvent = createEvent({
  initialValue: branchInitialValue,
});

/**
 * @deprecated
 * Alternative to useEvent(onBranchEvent) for class components.
 */
export const withUseOnBranchEvent = (Component) => (props) => {
  const branch = useEvent(onBranchEvent);
  return <Component selectedBranch={branch} {...props} />;
};

/*
  This event is used to store the current value of the date selection field,
  located in the top filter.

  TODO:
  1) Replace in the application the same repeated event
  2) Remove repeated event in src/modules/shared/events/date-event.js
*/
export const onDateEvent = createEvent({
  initialValue: new Date(),
});
